export default "__VITE_ASSET__fff7861c__"